const i = {
  styleOverrides: {
    root: ({ theme: o }) => ({
      padding: o.spacing(1, 2, 2),
      ".MuiAccordionDetails-root + &": {
        paddingTop: 0
      }
    })
  }
};
export {
  i as default
};
